import { useLocation } from "react-router-dom"

import { LoadingPage } from "src/components/loader"

// eslint-disable-next-line react/prop-types
function ProtectedRoute({ children }) {
  const location = useLocation()
  const path = location.pathname

  let state = {}
  if (path && path.startsWith("/")) {
    state = {
      returnTo: path,
    }
  }
  const stateParams = encodeURIComponent(JSON.stringify(state))

  const token = localStorage.getItem("token")
  if (!token) {
    const clientId = import.meta.env.VITE_WORKOS_CLIENT_ID
    const redirect = import.meta.env.VITE_WORKOS_REDIRECT_URL
    let fullUrl = `https://auth-api.plainsignal.io/user_management/authorize?client_id=${clientId}&redirect_uri=${redirect}&response_type=code&provider=authkit`
    if (stateParams) {
      fullUrl += `&state=${stateParams}`
    }
    window.location.href = fullUrl
    return <LoadingPage />
  }

  return children
}

export { ProtectedRoute }
